import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { BuildingFormComponent } from './building-form/building-form.component';

@NgModule({
  declarations: [BuildingFormComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class BuildingsModule { }
